import { render, staticRenderFns } from "./Commentedit.vue?vue&type=template&id=741c5560&scoped=true&"
import script from "./Commentedit.vue?vue&type=script&lang=js&"
export * from "./Commentedit.vue?vue&type=script&lang=js&"
import style0 from "./Commentedit.vue?vue&type=style&index=0&id=741c5560&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741c5560",
  null
  
)

export default component.exports